import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

// Crear el context
export const CategoryContext = createContext();

// Crear el provider que es donde se encuetnran las funciones y el estado

const CategoryProvider = (props) => {
    // Crear el state del context
    const [ categories, setCategory ] = useState([]);
    // Ejecutar llamado a la API
    useEffect(() => {
        const getCategory = async () => {
            const url = 'https://www.thecocktaildb.com/api/json/v1/1/list.php?c=list';
            const category = await axios.get(url);
            setCategory(category.data.drinks);
        }
        getCategory();
    }, []);

    return(
        <CategoryContext.Provider
            value={{
                categories
            }}
        >
            { props.children }
        </CategoryContext.Provider>
    )
}

export default CategoryProvider;